import { constructURL } from 'helpers/url';
import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['autocomplete'];

  select(event) {
    const { target } = event.detail;
    const value = target.getAttribute('value');
    const url = constructURL(this.src, { payroll_period_id: value });
    this.element.src = url.toString();
  }

  loading() {
    if (this.hasAutocompleteTarget) {
      this.autocompleteTarget.disabled = true;
    }
  }

  loaded() {
    if (this.hasAutocompleteTarget) {
      this.autocompleteTarget.disabled = false;
    }
  }

  get src() {
    return this.element.getAttribute('src');
  }
}
